import { html, LitElement, } from 'lit-element';

export class IconStar extends LitElement {
  static get properties() {
    return {
      active: { type: Boolean, },
      width: { type: Number, reflect: true, },
      height: { type: Number, reflect: true, },
    };
  }

  constructor() {
    super();
    this.width = 20;
    this.height = 20;
  }
  
  render() {
    return html`
    ${this.active
    ? html`<svg width="${this.width}" height="${this.height}" version="1.1" id="레이어_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 132 132" style="enable-background:new 0 0 132 132;" xml:space="preserve"><style type="text/css">.st0{fill:#EBBA53;}</style><g id="Icon_awesome-star-2"><path class="st0" d="M62.1,33.8l-8.8,17.9l-19.8,2.9c-2.4,0.4-4,2.6-3.6,4.9c0.1,0.9,0.6,1.8,1.3,2.5l14.3,13.9l-3.4,19.7c-0.4,2.4,1.2,4.6,3.5,5c0.9,0.2,1.9,0,2.7-0.4L66,90.8l17.7,9.3c2.1,1.1,4.7,0.3,5.8-1.8c0.4-0.8,0.6-1.8,0.4-2.7l-3.4-19.7L100.9,62c1.7-1.7,1.7-4.4,0.1-6.1c-0.7-0.7-1.5-1.1-2.5-1.3l-19.8-2.9l-8.8-17.9c-1.1-2.1-3.7-3-5.8-1.9C63.2,32.3,62.6,32.9,62.1,33.8L62.1,33.8z"/></g></svg>`
    : html`<svg width="${this.width}" height="${this.height}" version="1.1" id="레이어_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 132 132" style="enable-background:new 0 0 132 132;" xml:space="preserve"><style type="text/css">.st0{fill:#D6D6D6;}</style><g id="Icon_awesome-star"><path class="st0" d="M62.1,33.8l-8.8,17.9l-19.8,2.9c-2.4,0.4-4,2.6-3.6,4.9c0.1,0.9,0.6,1.8,1.3,2.5l14.3,13.9l-3.4,19.7c-0.4,2.4,1.2,4.6,3.5,5c0.9,0.2,1.9,0,2.7-0.4L66,90.8l17.7,9.3c2.1,1.1,4.7,0.3,5.8-1.8c0.4-0.8,0.6-1.8,0.4-2.7l-3.4-19.7L100.9,62c1.7-1.7,1.7-4.4,0.1-6.1c-0.7-0.7-1.5-1.1-2.5-1.3l-19.8-2.9l-8.8-17.9c-1.1-2.1-3.7-3-5.8-1.9C63.2,32.3,62.6,32.9,62.1,33.8L62.1,33.8z"/></g></svg>`}    
    `;
  }
}

customElements.define('icon-star', IconStar);